export default "__VITE_ASSET__DGCeS2jV__"